import {
  asiakasAuth_cacheName,
  asiakasPersonSetting_cacheName,
  asiakas_cacheName,
  cache_clear,
  cache_read,
  cache_write,
  person_cacheName,
} from "src/components/js/CacheFunctions";
import { checkResponse } from "src/components/js/statics1";

export default class asiakasAuthClass {
  constructor() {
    this.isLoaded = false;
    this.isSettingsLoaded = false;
    this.read = true; // read permission to asiakas, this is the minimun for opening anything
    this.edit = false; // edit permission to asiakas, tyomaa and keikka
    this.originalEdit = false; // edit permission to asiakas, tyomaa and keikka
    this.listPersons = false; // allow listing of asiakas, tyomaa and keikka persons
    this.addPerson = false; // allow add/remove asiakas, tyomaa and keikka persons
    this.editPerson = false; // allow change of main contact of asiakas, tyomaa and keikka
    this.settings = [];
  }
  setAuthDataFromJson(jsonData) {
    try {
      this.read = true; // may read
      this.edit = jsonData.editAsiakas || false; // allow edit asiakas data
      this.originalEdit = jsonData.editAsiakas || false; // allow edit asiakas data
      this.listPersons = jsonData.listAsiakasPersons || false; // allow list of asiakas persons
      this.addPerson = jsonData.addAsiakasPerson || false; // allow add and delete of asiakas person
      this.editPerson = jsonData.editAsiakasMainPerson || false; // allow edit of individial persons
      this.isLoaded = true;
    } catch (err) {
      console.log(err);
    }
  }

  getAsiakasPersonSetting = (asiakasPersonSettingTypeIds, pvm = new Date()) => {
    if (Array.isArray(asiakasPersonSettingTypeIds)) {
      for (let i = 0; i < asiakasPersonSettingTypeIds.length; i++) {
        const result = this.getAsiakasPersonSetting(asiakasPersonSettingTypeIds[i], pvm);
        if (result) return result;
      }
      return null;
    }

    if (!this.settings) return null;
    const setting = this.settings.find(
      (setting) => setting.asiakasPersonSettingTypeId == asiakasPersonSettingTypeIds
    );
    if (!setting) return null;
    if (pvm !== null) {
      if (setting.startDate !== null && setting.startDate > pvm) return null;
      if (setting.endDate !== null && setting.endDate < pvm) return null;
    }
    return setting;
  };

  async fetchAsiakasPersonSettingType(asiakasPersonSettingTypeId, personId, token) {
    if (asiakasPersonSettingTypeId == null || asiakasPersonSettingTypeId == 0) return;
    try {
      const url = "/api/asiakas/personSettingType/get/" + asiakasPersonSettingTypeId;
      const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          asiakasPersonSettingTypeId: asiakasPersonSettingTypeId,
          personId: personId,
        }),
      });
      const cResponse = await checkResponse(
        response,
        "asiakasAuthClass.js:fetchAsiakasPersonSettingType"
      );
      if (!cResponse.success) return null;
      const result = cResponse.data;
      if (response.status > 399) {
        console.log(result);
        return null;
      }
      return result;
    } catch (err) {
      console.log(err);
    }
  }

  // hakee asiakaslistan sen perusteella mitä henkilö saa nähdä
  // esim typeId=1:isTarjousAdmin hakee kaikki asiakkaat joille henkilö saa tehdä tarjouksia
  async fetchAsiakasListByPersonSettingType(asiakasPersonSettingTypeId, personId, token) {
    if (asiakasPersonSettingTypeId == null || asiakasPersonSettingTypeId == 0) return;
    try {
      const url =
        "/api/asiakasPersonSettings/getAsiakasList/" + asiakasPersonSettingTypeId + "/" + personId;
      const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          asiakasPersonSettingTypeId: asiakasPersonSettingTypeId,
          personId: personId,
        }),
      });
      const cResponse = await checkResponse(
        response,
        "asiakasAuthClass:fetchAsiakasListByPersonSettingType"
      );
      if (!cResponse.success) return null;
      const json = cResponse.data;
      if (response.status > 399) {
        console.log(json);
        return null;
      }
      return json;
    } catch (err) {
      console.log(err);
    }
  }

  get isAnyAdmin() {
    if (this.getAsiakasPersonSetting(2) != null) return true;
    if (this.getAsiakasPersonSetting(6) != null) return true;
    if (this.getAsiakasPersonSetting(1) != null) return true;
    if (this.getAsiakasPersonSetting(11) != null) return true;
    return false;
  }
  get isAnyWorker() {
    if (this.getAsiakasPersonSetting(8) != null) return true;
    if (this.getAsiakasPersonSetting(9) != null) return true;
    if (this.getAsiakasPersonSetting(2) != null) return true;
    if (this.getAsiakasPersonSetting(6) != null) return true;
    if (this.getAsiakasPersonSetting(1) != null) return true;
    if (this.getAsiakasPersonSetting(11) != null) return true;
    return false;
  }

  get isAsiakasAdmin() {
    const r = this.getAsiakasPersonSetting(2);
    return r !== null;
  }
  get isAsiakasEditor() {
    const a = this.getAsiakasPersonSetting(6) != null;
    return a;
  }
  get isTarjousAdmin() {
    return this.getAsiakasPersonSetting(1) != null;
  }
  get isLaskuAdmin() {
    return this.getAsiakasPersonSetting(5) != null;
  }
  get isAttachmentHandler() {
    return this.getAsiakasPersonSetting(10) != null;
  }
  get isAssignee() {
    return this.getAsiakasPersonSetting(16) != null;
  }
  get isPumppari() {
    const r = this.getAsiakasPersonSetting(8); // || this.isAsiakasAdmin;
    return r != null;
  }
  get isTyösuhteessa() {
    return this.getAsiakasPersonSetting(9) != null;
  }
  get isKeikkaHandler() {
    return this.getAsiakasPersonSetting(11) != null;
  }
  get isSijaintiHandler() {
    return this.getAsiakasPersonSetting(12) != null;
  }
  get isVehicleHandler() {
    return this.getAsiakasPersonSetting(13) != null;
  }
  get isTuoteHandler() {
    return this.getAsiakasPersonSetting(14) != null;
  }

  get asiakasAuthHash() {
    return (
      (this.read ? 2 : 1) +
      (this.edit ? 4 : 1) +
      (this.listPersons ? 8 : 1) +
      (this.addPerson ? 16 : 1) +
      (this.editPerson ? 32 : 1) +
      (this.isLoaded ? 64 : 1)
    );
  }
}

export async function fetchAsiakasNimiList_not_used(asiakasId, token) {
  if (asiakasId == null || asiakasId == 0) return;
  try {
    const url = "/api/asiakas/nimiList/get/" + asiakasId;
    const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "asiakasAuthClass.js:fetchAsiakasNimiList");
    if (!cResponse.success) return null;
    const result = cResponse.data;
    if (response.status > 399) {
      console.log(result);
      return false;
    }
    return result;
  } catch (err) {
    console.log(err);
  }
}
export async function fetchAllAsiakasPersonSettingTypes(token) {
  try {
    const url = "/api/asiakasPersonSettings/getAllTypes";
    const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(
      response,
      "asiakasAuthClass.js:fetchAllAsiakasPersonSettingTypes"
    );
    if (!cResponse.success) return null;
    return cResponse.data;
  } catch (err) {
    console.log(err);
  }
}

export async function fetchAsiakasPersonSettings(
  asiakasId,
  personId,
  token,
  useCache = true,
  options = {}
) {
  if (asiakasId == null || asiakasId == 0) return;
  try {
    const url = "/api/asiakasPersonSettings/get/" + asiakasId + "/" + personId;
    const fullUrl = import.meta.env.VITE_SERVER_URL + url;
    if (useCache) {
      const c = cache_read(asiakasAuth_cacheName, fullUrl);
      if (c) return c;
    }
    const response = await fetch(fullUrl, {
      method: "GET",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      signal: options ? options.signal : undefined,
    });
    const cResponse = await checkResponse(
      response,
      "asiakasAuthClass.js:fetchAsiakasPersonSettings"
    );
    if (!cResponse.success) return null;
    for (let i = 0; i < cResponse.data.length; i++) {
      if (cResponse.data[i].startDate)
        cResponse.data[i].startDate = new Date(cResponse.data[i].startDate);
      if (cResponse.data[i].endDate)
        cResponse.data[i].endDate = new Date(cResponse.data[i].endDate);
    }

    cache_write(asiakasAuth_cacheName, fullUrl, cResponse.data, 360);
    return cResponse.data;
  } catch (err) {
    console.log(err);
  }
}

function clearCache() {
  cache_clear(asiakasAuth_cacheName);
  cache_clear(asiakas_cacheName);
  cache_clear(person_cacheName);
  cache_clear(asiakasPersonSetting_cacheName);
}

export async function addAsiakasPersonSetting(asiakasId, personId, personSettingTypeId, token) {
  if (asiakasId == null || asiakasId == 0) return;
  try {
    clearCache();
    const url = "/api/asiakasPersonSettings/add";
    const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        asiakasId: asiakasId,
        personId: personId,
        personSettingTypeId: personSettingTypeId,
      }),
    });
    // if (!(await checkResponse(response).success)) return null;
    return response.ok;
  } catch (err) {
    console.log(err);
  }
}

export async function deleteAsiakasPersonSetting(asiakasPersonSettingId, token) {
  const url = "/api/asiakasPersonSettings/delete/" + asiakasPersonSettingId;
  clearCache();

  try {
    const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
      method: "DELETE",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.ok;
  } catch (err) {
    console.log(err);
  }
}
